import { render } from "./screen.vue?vue&type=template&id=6e5bcbff&scoped=true"
import script from "./screen.vue?vue&type=script&lang=js"
export * from "./screen.vue?vue&type=script&lang=js"

import "./screen.vue?vue&type=style&index=0&id=6e5bcbff&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5bcbff"]])

export default __exports__